import { layoutParagraph, resolveFont, resolveLineHeightPx, toPx } from "../text";

const BLURB_ALIGNMENTS = new Set(["left", "right", "center", "justify"]);

// Paragraph.js: one <p> at min(100, column_width × columns)% of the block,
// centered, padded by half the project gutter on each side.
export function layoutBlurb(ctx) {
  const { ops, measurer, options, items, settings, fontStyle, left, width, top } = ctx;
  const style = fontStyle?.blurb || {};
  const columns = Math.max(1, Number(options?.columns) || 1);
  const columnWidth = Number(options?.column_width) || 100;
  const widthPct = Math.min(100, Math.max(1, columnWidth * columns));
  const align = BLURB_ALIGNMENTS.has(options?.text_alignment)
    ? options.text_alignment
    : "center";
  const gutterHalf = (Number(settings?.gutter) || 0) / 2;

  const boxWidth = (width * widthPct) / 100;
  const boxLeft = left + (width - boxWidth) / 2;
  const font = resolveFont(style, { size: 18 });
  const lineHeight = (style.lineHeight ?? 1.1) + 0.2;

  const height = layoutParagraph(ops, {
    measurer,
    font,
    text: items?.[0]?.blurb || "",
    left: boxLeft + gutterHalf,
    width: Math.max(0, boxWidth - gutterHalf * 2),
    top,
    align,
    lineHeightPx: resolveLineHeightPx(font, lineHeight),
    color: style.color,
    decoration: style.textDecoration,
  });
  return height + toPx(style.marginBottom, 0);
}
